export default "__VITE_ASSET__801309d3__"